<template>
	<common-view :element="element" :formData="formData">
		<div class="title" :data-required="element.isRequired == '1' ? '*' : ''">{{questionName}}</div>
		<div class="tips" v-show="element.tipsText" v-html="tipsText"></div>
		<div class="option">
			<el-radio-group :value="value">
				<el-radio v-for="item in element.itemList" :key="item.itemCode" :label="item.itemCode">{{item.itemName}}</el-radio>
			</el-radio-group>
		</div>
	</common-view>
</template>

<script>
import CommonView from "../CommonView";

export default {
	name: "DwJudge",
	computed: {
		questionName() {
			return this.element.questionName.replace(/[\n]/g, '');
		},
		tipsText() {
			return this.element.tipsText.replace(/[\n]/g, '<br />');
		},
	},
	components: {
		CommonView,
	},
	model: {
		prop: "value",
		event: "change",
	},
	props: {
		formData: {
			type: Object
		},
		element: {
			type: Object,
		},
		value: {},
	},
};
</script>


<style lang="scss" scoped>
.title {
	width: 100%;
	// height: 30px;
	line-height: 30px;
	font-size: 14px;
	color: #666;
	line-height: 1.5;
	position: relative;

	&::before {
		content: attr(data-required);
		color: #F56C6C;
		position: absolute;
		top: 0;
		left: -10px;
	}
}

.tips {
	width: 100%;
	// height: 30px;
	line-height: 30px;
	font-size: 12px;
	color: #666;
	line-height: 1.5;
	padding-left: 14px;
}

.option {
	padding: 0 5px;

	& .el-radio {
		display: block;
		margin: 10px;
	}
}
</style>